var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.531 6.28104L9.53104 18.281C9.46139 18.3508 9.37867 18.4061 9.28762 18.4438C9.19657 18.4816 9.09898 18.501 9.00042 18.501C8.90185 18.501 8.80426 18.4816 8.71321 18.4438C8.62216 18.4061 8.53945 18.3508 8.46979 18.281L3.21979 13.031C3.07906 12.8903 3 12.6994 3 12.5004C3 12.3014 3.07906 12.1105 3.21979 11.9698C3.36052 11.8291 3.55139 11.75 3.75042 11.75C3.94944 11.75 4.14031 11.8291 4.28104 11.9698L9.00042 16.6901L20.4698 5.21979C20.6105 5.07906 20.8014 5 21.0004 5C21.1994 5 21.3903 5.07906 21.531 5.21979C21.6718 5.36052 21.7508 5.55139 21.7508 5.75042C21.7508 5.94944 21.6718 6.14031 21.531 6.28104Z",
    fill: "#004EA8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.6b7c80fa.svg";
export { ForwardRef as ReactComponent };